import { findNewspaperCover, parseNewspaper } from './newspaperContent';

export const toPwaPost = (post) => {
  const image = (post.media || []).find((item) => item.type === 'IMAGE' && item.role === 'COVER')
    || (post.media || []).find((item) => item.type === 'IMAGE');
  const video = (post.media || []).find((item) => item.type === 'VIDEO');
  const newspaper = post.type === 'ARTICLE' ? parseNewspaper(post.content) : null;
  const type = String(post.type || 'STANDARD').toLowerCase() === 'standard'
    ? 'post'
    : String(post.type || '').toLowerCase();
  return {
    ...post,
    __backend: true,
    giftTotals: post.giftTotals || post.engagement?.giftTotals || [],
    blocked: Boolean(post.moderationBlocked),
    hiddenFromFeed: Boolean(post.hiddenFromFeed),
    is_advertisement: Boolean(post.advertisement),
    createdBy: post.author?.id,
    type,
    event: type === 'event',
    timestamp: Date.parse(post.publishedAt || post.createdAt || new Date().toISOString()),
    edited: post.updatedAt && post.updatedAt !== post.createdAt ? Date.parse(post.updatedAt) : null,
    content: newspaper ? '' : post.content,
    newspaper: newspaper || undefined,
    coverImage: image?.url || findNewspaperCover(newspaper),
    videoUrl: video?.url || '',
    video: video ? { url: video.url, thumbnail: image?.url || '' } : undefined,
    eventDetails: post.event || undefined,
    mentions: (post.mentionedUserIds || []).map((userId) => ({ userId })),
  };
};
